import { useNavigate } from "react-router-dom";

// Renders check-in instructions text, turning any mention of "4 digit code"
// / "4-digit code" into a link that opens the door-code flow on the home screen.
export function CheckinInstructions({ text, testid }) {
  const navigate = useNavigate();
  const content = text || "Instructions coming soon.";
  const parts = content.split(/(4[-\s]?digit code)/gi);
  return (
    <p className="text-brand-forest/80 leading-relaxed whitespace-pre-line" data-testid={testid}>
      {parts.map((part, i) =>
        /^4[-\s]?digit code$/i.test(part) ? (
          <button
            key={i}
            data-testid="instructions-door-code-link"
            onClick={() => navigate("/?door=1")}
            className="text-brand-terracotta font-semibold underline underline-offset-2 hover:opacity-80 active:scale-95 transition"
          >
            {part}
          </button>
        ) : (
          part
        )
      )}
    </p>
  );
}
